module.exports = __webpack_public_path__ + "assets/img/preview-click.bd6256b1.svg";